import React, { useMemo } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import GlassCard from '../../../customs/GlassCard';

import styles from '../ParentForm.module.css';

// Import useSelector and useDispatch to manage the global state
import { useSelector } from 'react-redux';
import RenderTable from '../../../customs/RenderTable';

const parentEntryFields = [
  'Full Name',
  'UFV Student ID',
  'Email Address',
  'Phone Number',
  'Pick-up Location',
  'Additional Person',
  'SMS Update',
];

const childEntryFields = ['First Name', 'Age', 'Gender', 'Wish'];

const PreviewInfo = ({ setStep }) => {
  const formValues = useSelector((state) => state.parent.parentForm.values);

  // Create entries for parent info => return array. For example, [['name', 'John Doe'],...[]]
  const parentEntries = useMemo(
    () =>
      Object.entries(formValues).filter((entry) => {
        return entry[0] !== 'children';
      }),
    [formValues]
  );

  parentEntries.forEach((entry, index) => {
    entry[0] = parentEntryFields[index];
  });

  if (parentEntries[4][1] === 'Abbotsford') {
    parentEntries[4][1] = 'Abbotsford: Abby Campus, S Building';
  } else if (parentEntries[4][1] === 'Chilliwack') {
    parentEntries[4][1] = 'Chilliwack: CEP Campus, A Building';
  }

  if (parentEntries[5][1] === '') {
    parentEntries[5][1] = 'None';
  }
  parentEntries[6][1] = parentEntries[6][1] ? 'Yes' : 'No';

  // Create entries for kids

  const childrenEntries = [];
  const children = formValues.children;
  children.forEach((child) => {
    const childEntry = Object.entries(child);
    const tempArr = [
      childEntry[3],
      childEntry[2],
      childEntry[1],
      childEntry[0],
    ];

    // Change the positions of entries
    tempArr.forEach((entry, index) => {
      entry[0] = childEntryFields[index];
    });

    childrenEntries.push(tempArr);
  });

  //   Change step
  const handleStep = (step) => {
    setStep(step);
  };

  return (
    <>
      <GlassCard sx={{ marginTop: '2rem', width: '100%' }}>
        <Box className={styles.editable}>
          <Typography variant='h5' component='h5'>
            Your Contact Information
          </Typography>
          <IconButton
            aria-label='edit'
            color='secondary'
            onClick={() => handleStep(0)}
          >
            <EditIcon />
          </IconButton>
        </Box>
      </GlassCard>
      <GlassCard sx={{ marginTop: '2rem', width: '100%' }}>
        <RenderTable cols={1} entries={parentEntries} />
      </GlassCard>

      <GlassCard sx={{ marginTop: '2rem', width: '100%' }}>
        <Box className={styles.editable}>
          <Typography variant='h5' component='h5'>
            Your Angel(s) Information
          </Typography>
          <IconButton
            aria-label='edit'
            color='secondary'
            onClick={() => handleStep(1)}
          >
            <EditIcon />
          </IconButton>
        </Box>
      </GlassCard>
      {childrenEntries.map((childEntries, index) => (
        <GlassCard key={index} sx={{ marginTop: '2rem', width: '100%' }}>
          <Box className={styles.editable}>
            <Typography variant='h5' component='h5' sx={{ marginBottom: '1rem' }}>
              Angel {index + 1}
            </Typography>
          </Box>

          <RenderTable cols={1} entries={childEntries} />
        </GlassCard>
      ))}
    </>
  );
};

export default PreviewInfo;
